import { render, staticRenderFns } from "./ModalUpdateVoucher.vue?vue&type=template&id=ddb643da&scoped=true"
import script from "./ModalUpdateVoucher.vue?vue&type=script&lang=js"
export * from "./ModalUpdateVoucher.vue?vue&type=script&lang=js"
import style0 from "./ModalUpdateVoucher.vue?vue&type=style&index=0&id=ddb643da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb643da",
  null
  
)

export default component.exports